import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button, Modal } from 'modules/common/components';
import { revokeEntireZVRDocument } from 'store/actions/zvrActions';
import bundesNotarKammerLogo from 'images/logo_bundesnotarkammer.svg';

interface RevokeHCPRegistrationModalProps {
  onClose: () => void;
  onRevokeSuccess?: () => void;
}

export default function RevokeHCPRegistrationModal({
  onClose,
  onRevokeSuccess,
}: RevokeHCPRegistrationModalProps) {
  const { t } = useTranslation(['zvrRegistration']);
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);

  const handleRevokeRegistration = async () => {
    setLoading(true);
    await dispatch(revokeEntireZVRDocument());
    onClose();
    if (onRevokeSuccess) onRevokeSuccess();
    setLoading(false);
  };

  return (
    <Modal show onHide={onClose}>
      <img
        src={bundesNotarKammerLogo}
        alt="Bundesnotarkammer logo"
        className="sm:t-w-1/2 t-w-5/6"
      />
      <h1 className="typo-alpha t-mt-9">
        {t('zvrRegistration:revoke_zvr_application_title')}
      </h1>
      <p className="typo-epsilon t-mt-4">
        {t('zvrRegistration:revoke_zvr_application_description')}
      </p>

      <div className="t-flex t-justify-end t-items-end t-mt-8 t-flex-col sm:t-flex-row">
        <div>
          <Button
            category="secondary"
            className="t-mr-0 sm:t-mr-3 t-py-2 t-mb-3 sm:t-mb-0"
            onClick={onClose}
            disabled={loading}
          >
            {t('zvrRegistration:cancel')}
          </Button>
        </div>

        <div>
          <Button
            className="t-py-2"
            onClick={handleRevokeRegistration}
            loading={loading}
          >
            {t('zvrRegistration:revoke_zvr_application_button')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
